// Auth tenant: cookie HttpOnly e a fonte de verdade do token agora; o
// localStorage so guarda memberId + role pra UI saber "estou logado?".
//
// Compat 1 ciclo: AuthState ainda expoe `token: string` (vazio na maioria
// dos paths -- preenchido apenas no flow de login que devolve o JWT na
// response). Quem precisa do header Authorization ainda funciona; quem
// soltar o header e enviar `credentials: 'include'` recebe o cookie.

export const TENANT_AUTH_STORAGE_KEY = "saquei_dev_token";
const MEMBER_ID_KEY = "saquei_dev_member_id";
const ROLE_KEY = "saquei_dev_role";
// Legacy: ainda lido em loadAuth pra detectar sessoes pre-cookie. Migracao
// progressiva -- proximo ciclo remove de vez.
const LEGACY_TOKEN_KEY = TENANT_AUTH_STORAGE_KEY;

export interface AuthState {
    /** Cookie HttpOnly carrega o JWT em prod. Vazio em sessoes pos-cookie. */
    token: string;
    memberId: string;
    role: string;
}

export function loadAuth(): AuthState | null {
    if (typeof localStorage === "undefined") return null;
    const memberId = localStorage.getItem(MEMBER_ID_KEY);
    const role = localStorage.getItem(ROLE_KEY);
    if (!memberId || !role) return null;
    // Legacy: sessoes antigas tem token em LS. Novas nao.
    const token = localStorage.getItem(LEGACY_TOKEN_KEY) ?? "";
    return { token, memberId, role };
}

export function saveAuth(auth: AuthState): void {
    // NAO persistir o JWT em localStorage -- cookie HttpOnly assumiu esse
    // papel. So memberId + role pra UI saber estado.
    localStorage.setItem(MEMBER_ID_KEY, auth.memberId);
    localStorage.setItem(ROLE_KEY, auth.role);
    // Limpa token legacy se existir.
    localStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function clearAuth(): void {
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem(MEMBER_ID_KEY);
    localStorage.removeItem(ROLE_KEY);
}
